import { CAMPAIGN_STATUS } from '@/client/constant'
import { isRepostEntryActionType } from '@/client/features/campaigns/utils/campaignUrlSettingTarget'

/** リポスト/引用系の収集状態。 */
export const RepostCollectionAlertState = {
  BEFORE_START: 'beforeStart',
  BEFORE_COLLECTION: 'beforeCollection', // 開催中 かつ 応募収集URL未設定.
  DURING_COLLECTION: 'duringCollection', // 開催中 かつ 応募収集URL設定済み
  FINAL_COLLECTION: 'finalCollection' // 終了後の最終集計中
} as const

export type RepostCollectionAlertState = (typeof RepostCollectionAlertState)[keyof typeof RepostCollectionAlertState]

export type RepostCollectionAlertInput = {
  type: string | null | undefined
  entryActionType: string | null | undefined
  status: number | null | undefined
  hasTweetPostUrl: boolean
}

// 「開催中」に対応する CAMPAIGN_STATUS 値（1=応募収集待ち / 2=応募収集中）
const DURING_EVENT_STATUSES: number[] = [CAMPAIGN_STATUS.BEFORE_COLLECTION, CAMPAIGN_STATUS.DURING_COLLECTION]

export const resolveRepostCollectionAlertState = (
  input: RepostCollectionAlertInput
): RepostCollectionAlertState | null => {
  const { type, entryActionType, status, hasTweetPostUrl } = input

  if (type !== 'keyword' || !isRepostEntryActionType(entryActionType) || status === null || status === undefined) {
    return null
  }

  if (status === CAMPAIGN_STATUS.BEFORE_EVENT) {
    return RepostCollectionAlertState.BEFORE_START
  }

  if (DURING_EVENT_STATUSES.includes(status)) {
    return hasTweetPostUrl ? RepostCollectionAlertState.DURING_COLLECTION : RepostCollectionAlertState.BEFORE_COLLECTION
  }

  if (status === CAMPAIGN_STATUS.DURING_FINAL_COLLECTION) {
    return RepostCollectionAlertState.FINAL_COLLECTION
  }

  // 最終集計完了（CAMPAIGN_STATUS.COLLECTION_COMPLETED）はアラートを表示しない
  return null
}
